import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Wrapper,
	StyledCheckbox,
	Label,
	ChevronWrapper,
	ChevronArrowRight,
} from './styles';

export default class TreeSelectorItem extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		label: PropTypes.string.isRequired,
		focused: PropTypes.bool,
		selected: PropTypes.bool,
		partiallySelected: PropTypes.bool,
		onFocus: PropTypes.func,
		onSelect: PropTypes.func,
		className: PropTypes.string,
	};

	static defaultProps = {
		focused: false,
		selected: false,
		partiallySelected: false,
		className: '',
		onFocus: () => {},
		onSelect: () => {},
	};

	handleFocus = () => {
		const { item, focused, onFocus } = this.props;

		onFocus(item, !focused);
	};

	handleChange = () => {
		const { item, selected, onSelect } = this.props;

		onSelect(item, !selected);
	};

	render() {
		const {
			label,
			focused,
			selected: checked,
			partiallySelected,
			onFocus,
			item,
			className,
		} = this.props;

		const isFocusable =
			!!onFocus && item.children && Object.values(item.children).length > 0;

		return (
			<Wrapper
				className={`${isFocusable && focused ? 'focused' : ''} ${className}`}
			>
				<StyledCheckbox
					checked={partiallySelected ? false : checked}
					indeterminate={partiallySelected}
					onChange={this.handleChange}
				/>

				<Label
					className={isFocusable ? '' : 'notFocusable'}
					role="link"
					tabIndex={0}
					onClick={isFocusable ? this.handleFocus : null}
				>
					{label}
				</Label>
				{isFocusable ? (
					<ChevronWrapper onClick={this.handleFocus} role="link" tabIndex={0}>
						<ChevronArrowRight />
					</ChevronWrapper>
				) : null}
			</Wrapper>
		);
	}
}
